import React, { Fragment, useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import styles from './app.styles'
import injectSheet from 'react-jss'
import { UserProvider, UserInspector } from 'pobble-components/dist/pobble-user'
import EnvironmentLine from 'pobble-components/dist/environment-line'
import PendingTeacherBar from 'pobble-components/dist/pending-teacher-bar'
import Header from 'pobble-components/dist/pobble-header'
import Navigation from '../navigation/navigation.container'
import { ToastContainer } from 'pobble-components/dist/toast'
import Routes from './routes/routes.container'
import { SubscriptionProvider } from 'pobble-components/dist/subscriptions'
import { ErrorBoundary } from 'pobble-components/dist/error-boundary'
import posthog from 'posthog-js'
import { useMe } from 'pobble-components/dist/pobble-user'

const APP_ROOT = process.env.REACT_APP_APP_ROOT || ''
const APP_PATH = process.env.REACT_APP_PATH || '/'

function PostHogIdentity() {
  const { me } = useMe()

  useEffect(
    () => {
      if (me) {
        const account = me.account
        posthog.identify(account.id)
        posthog.capture('landed on account spa')
      }
    },
    [me]
  )

  return null
}

const App = ({ me, meError }) => {
  return (
    <UserProvider
      fetchMe={() => (me ? Promise.resolve(me) : Promise.reject(meError))}>
      <PostHogIdentity />
      <SubscriptionProvider>
        <EnvironmentLine />
        <Header appUrl={APP_ROOT} />
        <PendingTeacherBar />
        <ErrorBoundary>
          <UserInspector
            haveRights={me => me.account.policy.can_see_profile_link}>
            <Router basename={APP_PATH}>
              <Fragment>
                <Navigation />
                <Routes />
              </Fragment>
            </Router>
          </UserInspector>
        </ErrorBoundary>
        <ToastContainer />
      </SubscriptionProvider>
    </UserProvider>
  )
}

export default injectSheet(styles)(App)
